/*  ==========================================================================
			Main.js - All non scroll based javascript functions
		========================================================================== */

document.addEventListener("DOMContentLoaded", function () {
  var testimonialsPerClick = 12;
  var $hiddenTestimonialsEl = $("#hidden-testimonials");
  var $grid = $(".posts--archive");
  var $loadMoreButton = $("#load-more-testimonials");

  // Testimonials markup is not present on all templates.
  if ($hiddenTestimonialsEl.length < 1 || $grid.length < 1 || $loadMoreButton.length < 1) {
    return;
  }

  var hiddenTestimonials = JSON.parse($hiddenTestimonialsEl.text() || "[]");

  if (!hiddenTestimonials.length) {
    $loadMoreButton.hide();
    return;
  }

  var currentIndex = 0;

  // IMPORTANT: wait for images BEFORE masonry init
  $grid.imagesLoaded(function () {
    $grid.masonry({
      itemSelector: ".gd-u",
      percentPosition: true,
      gutter: 0
    });
  });

  $loadMoreButton.on("click", function () {
    var htmlToAppend = hiddenTestimonials.slice(currentIndex, currentIndex + testimonialsPerClick);

    if (!htmlToAppend.length) {
      $(this).hide();
      return;
    }

    // Build elements but keep them invisible
    var $items = $(htmlToAppend.join("")).addClass("masonry-preload");

    // Append hidden (prevents flash)
    $grid.append($items);

    // Wait for images inside new items
    $items.imagesLoaded(function () {
      // Tell Masonry about new items
      $grid.masonry("appended", $items);

      // Force layout
      $grid.masonry("layout");

      // Now reveal AFTER layout is complete
      $items.removeClass("masonry-preload");
      plyrsInit($items[0].parentNode);
    });

    currentIndex += testimonialsPerClick;

    if (currentIndex >= hiddenTestimonials.length) {
      $loadMoreButton.hide();
    }
  });
});

// Remove the Fundraise Up donation form's max-width so it fills its container.
document.addEventListener("DOMContentLoaded", function () {
  var donationFormContainer = document.querySelector(".pageheader__form");

  if (!donationFormContainer) {
    return;
  }

  function removeDonationFormMaxWidth() {
    var donationFormIframe = donationFormContainer.querySelector('iframe#XBTWRVUS[title="Donation Form"]');

    if (
      donationFormIframe &&
      (donationFormIframe.style.getPropertyValue("max-width") !== "none" ||
        donationFormIframe.style.getPropertyPriority("max-width") !== "important")
    ) {
      donationFormIframe.style.setProperty("max-width", "none", "important");
    }
  }

  removeDonationFormMaxWidth();

  // Fundraise Up inserts and restyles the iframe asynchronously, so watch the
  // container and reapply the max-width override whenever its form changes.
  var donationFormObserver = new MutationObserver(removeDonationFormMaxWidth);

  // Watch inline style changes and inserted elements, including all descendants.
  donationFormObserver.observe(donationFormContainer, {
    attributes: true,
    attributeFilter: ["style"],
    childList: true,
    subtree: true
  });
});

$(function () {
  var isMobile = false; //initiate as false
  var isIPad = false; //initiate as false

  // device detection
  if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    isMobile = true;
  }

  isIPad = navigator.userAgent.match(/iPad/i) != null;

  /*  ==========================================================================
			links
			========================================================================== */
  links__init();

  // Make sure these work on ninja forms too...
  jQuery(document).on("nfFormReady", function (e, layoutView) {
    // Your code goes here...
    links__init();
  });

  function links__init($context) {
    var $links = $("a").not(".noline, .noline a, .line--added");

    $links.each(function () {
      var $this = $(this);
      var $icon = $(".fa, .fas, .far, .fal, .fab", $this);

      if ($("img", $this).length < 1) {
        $this.wrapInner("<span class='linkline'>");
        $this.addClass("line--added");
        if ($icon.length > 0) {
          if ($icon.hasClass("fa--left")) {
            $icon.insertBefore($(".linkline", $this));
          } else {
            $icon.insertAfter($(".linkline", $this));
          }
        }
      }
    });
  } // links__init()

  /*  ==========================================================================
			scrolled
			========================================================================== */
  $(document).scroll(function (evt) {
    var y = $(this).scrollTop();
    if (y > 100) {
      $("body").addClass("hasscrolled");
    } else {
      $("body").removeClass("hasscrolled");
    }
  });

  /*  ==========================================================================
			scroll to has
			========================================================================== */

  if (window.location.hash) {
    var hash = window.location.hash;

    if ($(hash).hasClass("eventtab")) {
      $(hash).addClass("eventtab--open");
    }

    $("html, body").animate(
      {
        scrollTop: $(hash).offset().top - 50
      },
      1000
    );
  }

  $('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function (event) {
      // On-page links
      if (
        location.pathname.replace(/^\//, "") === this.pathname.replace(/^\//, "") &&
        location.hostname === this.hostname
      ) {
        // Figure out element to scroll to
        var target = $(this.hash);
        target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();

          $("html, body").animate(
            {
              scrollTop: target.offset().top
            },
            1000,
            function () {
              var $target = $(target);

              if (target.hasClass("eventtab")) {
                target.addClass("eventtab--open");
              }
            }
          );
        }
      }
    });

  /*  ==========================================================================
			sharinglinks
			========================================================================== */

  $(".sharelink--popup").click(function (e) {
    e.preventDefault();
    window.open($(this).attr("href"), "share-dialog", "width=550,height=436");
  });

  /*  ==========================================================================
			faqs
			========================================================================== */

  // For grouped FAQs, only one open at a time and the active item can close
  $(document).on("click", ".faqs__grouped .faq", function (e) {
    if ($(e.target).is("a, button, input, select, textarea, label")) {
      return;
    }
    var $faq = $(this);
    var $groupedParent = $faq.closest(".faqs__grouped");
    if ($groupedParent.length > 0) {
      var wasOpen = $faq.hasClass("faq--open");

      $(".faq", $groupedParent).removeClass("faq--open");
      if (!wasOpen) {
        $faq.addClass("faq--open");
      }
      return;
    }
  });

  // For non-grouped FAQs, only one open at a time and the active item can close
  $(document).on("click", ".faqs:not(.faqs__grouped) > .faq > .faq__question", function () {
    var $faq = $(this).closest(".faq");
    var $faqs = $faq.closest(".faqs");
    var wasOpen = $faq.hasClass("faq--open");

    $(".faq", $faqs).removeClass("faq--open");
    if (!wasOpen) {
      $faq.addClass("faq--open");
    }
  });

  groupedFaqs__init();

  function groupedFaqs__init() {
    var $groupedFaqBlocks = $(".flex--faqs.faqs--grouped");

    if ($groupedFaqBlocks.length < 1) {
      return;
    }

    $groupedFaqBlocks.each(function () {
      var $block = $(this);
      var $toggles = $(".faq--group-toggle", $block);
      var $groups = $(".faqs__grouped", $block);

      if ($toggles.length < 1 || $groups.length < 1) {
        return;
      }

      function activateGroup(index) {
        $toggles.each(function () {
          var $toggle = $(this);
          var isActive = String($toggle.attr("data-group-index")) === String(index);

          $toggle.toggleClass("is-active", isActive);
          $(".faqs--grouped-toggle", $toggle).attr("aria-expanded", isActive ? "true" : "false");
        });

        $groups.each(function () {
          var $group = $(this);
          var isActive = String($group.attr("data-group-index")) === String(index);

          $group.toggleClass("is-active", isActive);
          $group.css("display", isActive ? "block" : "none");
        });

        var $activeGroup = $groups.filter('[data-group-index="' + index + '"]');
        $(".faq", $activeGroup).removeClass("faq--open");
        $(".faq", $activeGroup).first().addClass("faq--open");
      }

      // Respect existing active markup if present, otherwise default to the first group.
      var $initialActiveToggle = $toggles.filter(".is-active").first();
      var initialIndex = $toggles.first().attr("data-group-index");

      if ($initialActiveToggle.length) {
        initialIndex = $initialActiveToggle.attr("data-group-index");
      }

      activateGroup(initialIndex);

      $block.on("click", ".faqs--grouped-toggle, .faq--group-toggle", function () {
        var index = $(this).closest(".faq--group-toggle").attr("data-group-index");
        activateGroup(index);
      });

      $block.on("keydown", ".faqs--grouped-toggle, .faq--group-toggle", function (event) {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          var index = $(this).closest(".faq--group-toggle").attr("data-group-index");
          activateGroup(index);
        }
      });
    });
  }

  /*  ==========================================================================
			Single Event Tabs
			========================================================================== */

  $(".eventtab__header").click(function () {
    $(this).closest(".eventtab").toggleClass("eventtab--open");
  });

  /*  ==========================================================================
			steps accordion
			========================================================================== */

  stepsAccordion__init();

  function stepsAccordion__init() {
    var $accordions = $(".flex--steps-accordion");
    if ($accordions.length < 1) {
      return;
    }

    function isMobileSteps() {
      return window.innerWidth < 1000;
    }

    $accordions.each(function () {
      var $accordion = $(this);
      var $stepItems = $accordion.find(".step__content");
      var $stepImages = $accordion.find(".step__image");

      function openStep(index) {
        if (isMobileSteps()) {
          // On mobile, open all steps
          $stepItems.each(function () {
            $(this).addClass("is-active");
            $(this).find(".step__question").attr("aria-expanded", "true");
            $(this).find(".step__answer").stop(true, true).slideDown(0);
          });
          $stepImages.each(function () {
            $(this).addClass("is-active").show();
          });
        } else {
          $stepItems.removeClass("is-active");
          $stepItems.find(".step__question").attr("aria-expanded", "false");
          $stepItems.find(".step__answer").stop(true, true).slideUp(250);

          if (typeof index !== "undefined") {
            var $activeItem = $stepItems.filter('[data-step-index="' + index + '"]');
            $activeItem.addClass("is-active");
            $activeItem.find(".step__question").attr("aria-expanded", "true");
            $activeItem.find(".step__answer").stop(true, true).slideDown(250);

            $stepImages.removeClass("is-active").hide();
            var $activeImage = $stepImages.filter('[data-step-index="' + index + '"]');
            $activeImage.addClass("is-active").show();
          }
        }
        if (typeof lazyLoadInstance !== "undefined" && lazyLoadInstance && lazyLoadInstance.update) {
          lazyLoadInstance.update();
        }
      }

      // On load, open all on mobile, first only on desktop
      function openAllSteps() {
        $stepItems.each(function () {
          $(this).addClass("is-active");
          $(this).find(".step__question").attr("aria-expanded", "true");
          $(this).find(".step__answer").stop(true, true).slideDown(0);
        });
        $stepImages.each(function () {
          $(this).addClass("is-active").show();
        });
      }

      if (isMobileSteps()) {
        openAllSteps();
      } else {
        openStep(0);
      }

      $accordion.on("click", ".step__content", function (event) {
        if ($(event.target).closest("a, button, input, select, textarea, label").length > 0) {
          return;
        }
        if (isMobileSteps()) {
          // On mobile, always keep all open
          openAllSteps();
          return;
        }
        var $step = $(this);
        if ($step.hasClass("is-active")) {
          return;
        }
        var index = $step.data("step-index");
        openStep(index);
      });

      $accordion.on("keydown", ".step__question", function (event) {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          $(this).trigger("click");
        }
      });

      // Debounced resize handler, only trigger when crossing 1000px threshold
      var resizeTimeout;
      var lastIsMobile = isMobileSteps();
      $(window).on("resize", function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function () {
          var nowIsMobile = isMobileSteps();
          if (nowIsMobile !== lastIsMobile) {
            if (nowIsMobile) {
              openStep();
            } else {
              openStep(0);
            }
            lastIsMobile = nowIsMobile;
          }
        }, 250); // 250ms debounce
      });
    });
  }

  /*  ==========================================================================
			pagenav
			========================================================================== */

  pagenav__init();

  function pagenav__init() {
    var $mobnav2 = $(".mobnav");
    var $mobnavinner2 = $(".mobnav__bd", $mobnav2);
    var $mobnavtoggle2 = $(".mobnav-toggle");
    var mobnavopenclass2 = "mobnavopen";

    $mobnavtoggle2.on("click", function () {
      $mobnav2.slideToggle();
      $("body").toggleClass("mobnavopen");
      $(".pagenav__toggle").removeClass("open");
      $(".pagenav").removeClass("pagenav--open");
    });

    if ($(".pagenav__toggle") && $(".pagenav__toggle").length > 0) {
      $(".mobtools__pagenav").html($(".pagenav__toggle"));
    }

    $(document).on("click touchend", ".pagenav__toggle", function (e) {
      $(this).toggleClass("open");
      e.preventDefault();
      $mobnav2.slideUp();
      $("body").removeClass("mobnavopen");
      $(".pagenav").toggleClass("pagenav--open");
    });

    var $pagenavheight = $(".pagenav").height();

    if ($pagenavheight === 0) {
      $(".pageheader").css("padding-top", "");
      $(".pageheader").css("margin-top", "");
    } else if ($pagenavheight == null) {
    } else if ($(".snowdonsiteheader").length > 0) {
      $pagenavheight = $(".snowdonsiteheader").height();

      $(".pageheader").css("padding-top", $pagenavheight);
    } else if (!$(".main--singlepost")) {
      $(".pageheader").css("padding-top", $pagenavheight);
      $(".pageheader").css("margin-top", -$pagenavheight);
    }

    $(window).resize(pagenav__resize);
  } // pagenav__init()

  function pagenav__resize() {
    var $pagenavheight = $(".pagenav").height();
    if ($pagenavheight === 0) {
      $(".pageheader").css("padding-top", "");
      $(".pageheader").css("margin-top", "");
    } else if ($pagenavheight == null) {
    } else if ($(".snowdonsiteheader").length > 0) {
      $pagenavheight = $(".snowdonsiteheader").height();

      $(".pageheader").css("padding-top", $pagenavheight);
    } else if (!$(".main--singlepost")) {
      $(".pageheader").css("padding-top", $pagenavheight);
      $(".pageheader").css("margin-top", -$pagenavheight);
    }
    if ($(".pagenav").hasClass("pagenav--open")) {
      // $(".pagenav").height($('.pagenav__inner').outerHeight(true));
    }
  } // pagenav__resize()

  /*  ==========================================================================
			sitenav
			========================================================================== */

  var $sitenav = $(".sitenav");
  var $sitenavitems = $("li[data-sitenavsection]", $sitenav).not(".hover--avoid");
  var $sitenavdropdown = $(".sitenavdropdown");

  var $body = $("body");

  var overclass = "over";
  var navopenbodyclass = "sitenavopen";
  var activesectionclass = "sitenavsection--active";
  var navopen = false;
  var $currentli = false;
  var windowtimer = false;

  if (!isMobile) {
    sitenav__init();
  }

  function sitenav__init() {
    if (isIPad) {
      $sitenavitems.on("tap click hover", function (e) {
        var $this = $(this);
        if ($this.attr("data-sitenavsection") === undefined) {
          return true;
        }
        e.preventDefault();
        if ($this.hasClass("over")) {
          navopen = false;
          sitenav__close();
        } else {
          sitenavsection__open($this);
        }
      });
    } else {
      $sitenavitems.mouseover(sitenavitem__over).mouseout(sitenav__out);
      $sitenavdropdown.mouseover(sitenavsection__over).mouseout(sitenav__out);
    }
  } // sitenav__init()

  function sitenavitem__over() {
    var $this = $(this);

    if ($this.attr("data-sitenavsection") === undefined) {
      return false;
    }
    sitenavsection__open($this);
  } // sitenavitem__over()

  function sitenavsection__open($target_li) {
    var $this = $target_li;
    var $targetsection = $("#sitenavsection--" + $this.attr("data-sitenavsection"));

    var height = $("#sitenavsection--" + $this.attr("data-sitenavsection")).height();
    if ($("." + activesectionclass).length === 0) {
      $sitenavdropdown.css("height", height);
    } else {
      $sitenavdropdown.css("height", height);
    }

    navopen = true;
    if (windowtimer) {
      window.clearTimeout(windowtimer);
    }

    $("." + overclass, $sitenav).removeClass(overclass);
    $this.addClass(overclass);
    $body.addClass(navopenbodyclass);
    $currentli = $this;

    $("." + activesectionclass).removeClass(activesectionclass);
    $sitenavdropdown.attr("data-itemtarget", $this.data("sitenavsection"));

    $targetsection.addClass(activesectionclass);
  } //sitenavsection__open();

  function sitenavsection__over() {
    var $this = $(this);
    navopen = true;
    if (windowtimer) {
      window.clearTimeout(windowtimer);
    }
    $body.addClass(navopenbodyclass);
  } // sitenavitem__over()

  function sitenav__out() {
    navopen = false;
    windowtimer = window.setTimeout(sitenav__close, 250);
  } // sitenavitem__over()

  function sitenav__close() {
    if (!navopen) {
      $("." + activesectionclass).removeClass(activesectionclass);
      $body.removeClass(navopenbodyclass);
      if ($currentli) {
        $currentli.removeClass(overclass);
      }
      $sitenavdropdown.stop();
      $sitenavdropdown.css("height", 0);
    }
  } // sitenav__close

  $(".sitenav__item__dropdownarrow").click(function (e) {
    $(this).parent().toggleClass("sitenav__item--open");
    $(this).next().animate(
      {
        height: "toggle",
        opacity: "toggle"
      },
      "300"
    );
  });

  /*  ==========================================================================
		overlaynav
		========================================================================== */
  var $overlaynav = $(".overlaynav");
  var $overlaynavtoggle = $(".overlaynavtoggle");
  var overlaynavopenclass = "overlaynavopen";
  overlaynav__init();

  function overlaynav__init() {
    $overlaynavtoggle.on("click touchend", function (e) {
      e.preventDefault();
      if ($overlaynav.attr("data-status") !== "open") {
        // it's not open
        $overlaynav.attr("data-status", "open");
        $("body, html").addClass(overlaynavopenclass);
      } else {
        // it's open
        $overlaynav.attr("data-status", "closed");
        $("body, html").removeClass(overlaynavopenclass);
        $(".overlaynav").scrollTop(0);
      }
    });
  } // overlaynav__init()

  /*  ==========================================================================
			project/posts/events carousel
			========================================================================== */

  var $carousel = $(".carousel");

  if ($carousel.length > 0) {
    carousel__init();
  }

  function carousel__init() {
    $carousel.each(function () {
      var $this = $(this),
        padding = $(this).data("padding"),
        columns = $(this).data("column"),
        items = 4,
        responsive = {
          0: {
            items: 1
          },
          700: {
            items: 2
          },
          1200: {
            items: 4
          }
        };

      if (!padding) {
        padding = 10;
      }
      if (columns === 1) {
        items = 1;
        responsive = "";
      } else if (columns === 2) {
        items = 2;
        responsive = {
          0: {
            items: 2
          },
          700: {
            items: 1
          },
          1000: {
            items: 2
          }
        };
      }
      var $this_slidecount = $(".carousel__slide", $this).length;
      if ($this_slidecount > 0) {
        $this.owlCarousel({
          items: items,
          margin: padding,
          nav: false,
          dots: false,
          responsive: responsive,
          autoHeight: true
        });
      }
    });
  }

  $(".carousel__navitem--next").click(function () {
    $(this).parents(".carouselsection").find(".carousel").addClass("next");
    $(this).parents(".carouselsection").find(".carousel").trigger("next.owl.carousel");
  });
  $(".carousel__navitem--prev").click(function () {
    $(this).parents(".carouselsection").find(".carousel").trigger("prev.owl.carousel");
  });

  $carousel.on("resized.owl.carousel", function () {
    $carousel.trigger("next.owl.carousel");
  });

  $carousel.on("changed.owl.carousel", function (event) {
    lazyLoadInstance.update();
  });

  /*  ==========================================================================
			quoteslides
			========================================================================== */

  var $quoteslides = $(".quoteslides");

  if ($quoteslides.length > 0) {
    quoteslides__init();
  }

  function quoteslides__init() {
    var quotecarousel = $(".quoteslides").owlCarousel({
      items: 1,
      nav: true,
      dots: false,
      loop: false,
      autoplay: false,
      autoplayHoverPause: true,
      navText: [
        '<span class="fas fa-chevron-left"><span class="visuallyhidden>Previous</span></span>',
        '<span class="fas fa-chevron-right"><span class="visuallyhidden>Next</span></span>'
      ]
    });
  }

  /*  ==========================================================================
			Product Image Slider
			========================================================================== */

  var $productimages = $(".product__gallery");

  if ($productimages.length > 0) {
    productgallery__init();
  }

  function productgallery__init() {
    var productimagescarousel = $(".product__gallery").owlCarousel({
      items: 1,
      nav: true,
      dots: false,
      loop: false,
      autoHeight: true,
      autoplay: false,
      autoplayHoverPause: true,
      navText: [
        '<span class="fas fa-chevron-left"><span class="visuallyhidden>Previous</span></span>',
        '<span class="fas fa-chevron-right"><span class="visuallyhidden>Next</span></span>'
      ]
    });
  }

  /*  ==========================================================================
			Fade In Text Animation
			========================================================================== */
  $(".fadeInTextAnimation").each(function (index) {
    var characters = $(this).text().split("");

    var $this = $(this);
    $this.empty();
    $.each(characters, function (i, el) {
      $this.append("<span class='effect effect--fade effect--slideright'>" + el + "</span");
    });
  });

  /*  ==========================================================================
			flexslides
			========================================================================== */

  var $flexslides = $(".flexslides");

  if ($flexslides.length > 0) {
    flexslides__init();
  }

  function flexslides__init() {
    $flexslides.each(function () {
      var $this = $(this);
      var $this_slidecount = $(".flexslide", $this).length;
      if ($this_slidecount > 1) {
        $this
          .owlCarousel({
            loop: true,
            nav: false,
            dots: true,
            items: 1,
            startPosition: $this_slidecount,
            //autoplay: true,
            //autoplayTimeout: 5000,
            autoHeight: false
          })
          .waypoint({
            handler: function (direction) {
              if (direction === "down" && $this.data("alreadyscrolled") !== "true") {
                $this.trigger("next.owl.carousel").data("alreadyscrolled", "true");
              }
            },
            offset: "50%"
          });
      }
    });

    $flexslides.on("resized.owl.carousel", function () {
      $flexslides.trigger("next.owl.carousel");
    });

    $flexslides.on("changed.owl.carousel", function (event) {
      lazyLoadInstance.update();
    });
  } // flexslides__init()

  /*  ==========================================================================
			mobnav
			========================================================================== */

  var $mobnav = $(".mobnav");
  var $mobnavinner = $(".mobnav__bd", $mobnav);
  var $mobnavtoggle = $(".mobnav-toggle");
  var mobnavopenclass = "mobnavopen";

  /*  ==========================================================================
			fancybox
			========================================================================== */

  $(
    'a[href$=".jpg"]:not(.download-link, [data-fancybox="false"]),a[href$=".jpeg"]:not(.download-link, [data-fancybox="false"]), a[href$=".png"]:not(.download-link, [data-fancybox="false"]), a[href$=".gif"]:not(.download-link, [data-fancybox="false"])'
  ).fancybox({
    padding: "0",
    live: true,
    helpers: {
      overlay: {
        locked: false
      }
    }
  });

  $(".popoutmodal").fancybox({
    type: "inline",
    wrapCSS: "fancybox--popoutmodal",
    padding: "0",
    live: true,
    closeBtn: false,
    helpers: {
      overlay: {
        locked: false
      }
    }
  });

  $(document).on("click", ".custom__close", function (e) {
    e.preventDefault();
    e.stopPropagation();

    $.fancybox.close();
  });

  /*  ==========================================================================
			effects
			========================================================================== */

  var $effects = $(".effect");
  //var effectwaypoints = false;

  if ($effects.length > 0) {
    effects__init($effects);
  }

  /*  ==========================================================================
			pageheader background
			========================================================================== */

  // Fadein page header imagec
  $(".pageheader__img").bgLoaded({
    afterLoaded: function () {
      $("body").addClass("pageheaderimg--loaded");
    }
  });

  /*  ==========================================================================
			pageheader video background
			========================================================================== */

  var videoisrunning = false;
  var touch = Modernizr.touch;
  var videosetup = false;
  var $videocontainer = $(".pageheader__video");

  if ($videocontainer.length > 0) {
    pageheadervideo__init();
  }

  function pageheadervideo__init() {
    if ($videocontainer.length < 1) {
      $("body").addClass("noyoutube");
      return false;
    }

    if (!touch && $videocontainer.length > 0) {
      pageheadervideo__setup();
      $("body").addClass("has-videoheader");
    } else {
      $("body").addClass("novideo");
    }
  } // hpvideo__init()

  function pageheadervideo__setup() {
    $videocontainer.vide(
      {
        mp4: $videocontainer.attr("data-video-mp4"),
        webm: $videocontainer.attr("data-video-webm"),
        ogv: $videocontainer.attr("data-video-ogv"),
        poster: $videocontainer.attr("data-video-poster")
      },
      {
        muted: true,
        loop: true,
        autoplay: true,
        position: "50% 50%",
        resizing: true,
        posterType: "none"
      }
    );

    var instance = $videocontainer.data("vide");
    var videoinstance = instance.getVideoObject();

    var playing = false;

    videoinstance.addEventListener(
      "play",
      function (e) {
        $("body").addClass("has-videoheader--playing");
        playing = true;
      },
      true
    );

    // Need this function to fix header video on safari. As autoplay doesnt seem
    // to work on safari
    videoinstance.addEventListener(
      "canplaythrough",
      function () {
        if (!playing) {
          videoinstance.play();
        }
      },
      false
    );

    videosetup = true;
    videoisrunning = true;
  } // pageheadervideo__setup()

  /*  ==========================================================================
			popupsearch
			========================================================================== */

  var $searchtoggle = $(".searchpopup-toggle");
  var searchtoggleopenclass = "popupsearch--open";
  var $searchform = $(".searchpopupform");
  var $searchinput = $('input[name="s"]', $searchform);
  search__init();

  function search__init() {
    $searchtoggle.on("click touchend", function (e) {
      e.preventDefault();
      if (!$("body").hasClass(searchtoggleopenclass)) {
        // it's not open
        $("body").addClass(searchtoggleopenclass);
        if (!Modernizr.touch) {
          $searchinput.focus();
        }
      } else {
        // it's open
        $("body").removeClass(searchtoggleopenclass);
      }
    });

    $(".searchsubmit").click(function (e) {
      e.preventDefault();
      $searchform.submit();
    });

    $(document).keyup(function (e) {
      if ($("body").hasClass(searchtoggleopenclass)) {
        if (e.keyCode === 27) {
          $searchtoggle.first().click();
        }

        if (e.keyCode === 13) {
          $searchform.submit();
        }
      }
    });
  } // search__init()

  $(".searchpopup").on("click", function (e) {
    if (e.target !== this) {
      return;
    }

    // it's open
    $("body").removeClass(searchtoggleopenclass);
  });

  /*  ==========================================================================
			popupmodal
			========================================================================== */

  var modal_inited = false;

  // Make sure these work on ninja forms too...
  jQuery(document).on("nfFormReady", function (e, layoutView) {
    if (modal_inited === false) {
      modal__init();
      modal_inited = true;
    }
  });

  function modal__init() {
    $(document).on("click touchend", ".modalpopup-toggle", function (e) {
      $(".modalcontent").html($(this).data("text"));

      e.preventDefault();

      if (!$("body").hasClass("popupmodal--open")) {
        // it's not open
        $("body").addClass("popupmodal--open");
      } else {
        // it's open
        $("body").removeClass("popupmodal--open");
      }
    });
  } // modal__init()

  $(document).on("click", ".modalpopup", function (e) {
    if (e.target !== this) {
      return;
    }
    // it's open
    $("body").removeClass("popupmodal--open");
  });

  /*  ==========================================================================
			Line chart js
			========================================================================== */

  var $linecharts = $(".chart--line");

  if ($linecharts.length > 0) {
    charts__line_init();
  }

  function charts__line_init() {
    $linecharts.each(function () {
      var $chart = $(this);
      var $chartdata = $(".chart__data", $chart);
      var $chartcanvas = $(".chart__canvas", $chart);
      var $chartcanvas_el = $chartcanvas.get(0);
      var $chartlabels = $chart.data("labels-x");
      var $chartlabels_array = $chartlabels.split(",");

      var datasets_array = Array();

      $(".dataline", $chartdata).each(function () {
        var $dataset = $(this);
        var $dataset_color = $dataset.data("color");
        var $dataset_label = $dataset.data("label");
        var $dataset_data = $dataset.data("data");
        var $dataset_data_array = $dataset_data.split(",");

        datasets_array.push({
          label: $dataset_label,
          fill: false,
          lineTension: 0,
          borderWidth: 1,
          borderColor: $dataset_color,
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: $dataset_color,
          pointBackgroundColor: "#fff",
          pointBorderWidth: 1,
          pointHoverRadius: 7,
          pointHoverBackgroundColor: $dataset_color,
          pointHoverBorderColor: "rgba(220,220,220,1)",
          pointHoverBorderWidth: 2,
          pointRadius: 2,
          pointHitRadius: 10,
          data: $dataset_data_array,
          spanGaps: false
        });
      });

      new Chart($chartcanvas_el, {
        type: "line",
        data: {
          labels: $chartlabels_array,
          datasets: datasets_array
        },
        options: {
          legend: {
            display: false
          },
          tooltips: {
            backgroundColor: "#eeeeee",
            bodyFontColor: "#111111",
            titleFontColor: "#111111",
            titleMarginBottom: 10,
            xPadding: 10,
            yPadding: 10
          }
        }
      });
    });
  } // charts__line_init ()

  /*  ==========================================================================
			pie chart js
			========================================================================== */

  var $piecharts = $(".chart--pie");

  if ($piecharts.length > 0) {
    charts__pie_init();
  }

  function charts__pie_init() {
    $piecharts.each(function () {
      var $chart = $(this);
      var $chartdata = $(".chart__data", $chart);
      var $chartcanvas = $(".chart__canvas", $chart);
      var $chartcanvas_el = $chartcanvas.get(0);

      var data_labels = Array();
      var data_colors = Array();
      var data_values = Array();

      $(".datavalue", $chartdata).each(function () {
        //data_labels.push($(this).data('label'));
        data_labels.push(" ");
        data_colors.push($(this).data("color"));
        data_values.push($(this).data("val"));
      });

      new Chart($chartcanvas_el, {
        type: "pie",
        data: {
          labels: data_labels,
          datasets: [
            {
              data: data_values,
              backgroundColor: data_colors,
              borderWidth: 1
            }
          ]
        },
        options: {
          legend: {
            display: false
          },
          tooltips: {
            mode: "index",
            /*backgroundColor: "#eeeeee",
							bodyFontColor: "#111111",
							titleFontColor: "#111111",
							titleMarginBottom: 10, */
            titleFontSize: 0,
            xPadding: 10,
            yPadding: 10
          }
        }
      });
    });
  } // charts__pie_init ()

  /*  ==========================================================================
				bar chart js
				========================================================================== */

  var $barcharts = $(".chart--bar");

  if ($barcharts.length > 0) {
    charts__bar_init();
  }

  function charts__bar_init() {
    $barcharts.each(function () {
      var $chart = $(this);
      var $chartdata = $(".chart__data", $chart);
      var $chartcanvas = $(".chart__canvas", $chart);
      var $chartcanvas_el = $chartcanvas.get(0);

      var data_labels = Array();
      var data_colors = Array();
      var data_values = Array();

      $(".datavalue", $chartdata).each(function () {
        data_labels.push($(this).data("label"));
        data_colors.push($(this).data("color"));
        data_values.push($(this).data("val"));
      });

      new Chart($chartcanvas_el, {
        type: "bar",
        data: {
          labels: data_labels,
          datasets: [
            {
              data: data_values,
              backgroundColor: data_colors
            }
          ]
        },

        options: {
          scales: {
            xAxes: [
              {
                display: false,
                maxBarThickness: 50,
                barPercentage: 0.5
              }
            ],
            yAxes: [
              {
                ticks: {
                  beginAtZero: true
                }
              }
            ]
          },
          legend: {
            display: false
          },
          tooltips: {
            mode: "index",
            /*backgroundColor: "#eeeeee",
								bodyFontColor: "#111111",
								titleFontColor: "#111111",
								titleMarginBottom: 10, */
            titleFontSize: 0,
            xPadding: 10,
            yPadding: 10
          }
        }
      });
    });
  } // charts__line_init ()

  /*  ==========================================================================
		Stacked bar chart js
		========================================================================== */

  var $stackedcharts = $(".chart--barstacked");

  if ($stackedcharts.length > 0) {
    charts__stacked_init();
  }

  function charts__stacked_init() {
    $stackedcharts.each(function () {
      var $chart = $(this);
      var $chartdata = $(".chart__data", $chart);
      var $chartcanvas = $(".chart__canvas", $chart);

      $chartcanvas.html("<div class='stackedcanvas'></div>");
      var $stackedcanvas = $(".stackedcanvas", $chartcanvas);

      var data_values_array = Array();

      $(".datavalue", $chartdata).each(function () {
        data_values_array.push($(this).data("val"));
      });

      var data_values_total = data_values_array.reduce(charts__stacked_reduce, 0);

      $(".datavalue", $chartdata).each(function (i) {
        var $el = $(this);
        var el_val = $el.data("val");
        var el_percent = (el_val / data_values_total) * 100;
        $stackedcanvas.append(
          "<div class='stackeditem fontsize--tiny' style='height:" +
            el_percent +
            "%'><div class='stackeditem__bg' style='background-color:" +
            $el.data("color") +
            ";'></div><div class='stackeditem__info'><h4 class='stackeditem__value fontsize--tiny'>" +
            $el.data("val") +
            "</h4><div class='stackeditem__title'>" +
            $el.data("label") +
            "</div></div></div>"
        );
      });
    });
  } // charts__line_init ()

  /*  ==========================================================================
		Stacked bar chart js
		========================================================================== */

  var $horizstackedcharts = $(".chart--horizstacked");

  if ($horizstackedcharts.length > 0) {
    charts__horizstacked_init();
  }

  function charts__horizstacked_init() {
    $horizstackedcharts.each(function () {
      var $chart = $(this);
      var $chartdata = $(".chart__data", $chart);
      var $chartcanvas = $(".chart__canvas", $chart);

      $chartcanvas.html("<div class='stackedcanvas'></div>");
      $stackedcanvas = $(".stackedcanvas", $chartcanvas);

      var data_values_array = Array();

      $(".datavalue", $chartdata).each(function () {
        data_values_array.push($(this).data("val"));
      });

      var data_values_total = data_values_array.reduce(charts__stacked_reduce, 0);

      $(".datavalue", $chartdata).each(function (i) {
        var $el = $(this);
        var el_val = $el.data("val");
        var el_percent = (el_val / data_values_total) * 100;
        var el_class = el_percent < 5 ? "stackeditem--lt5" : "";
        $stackedcanvas.append(
          "<div class='stackeditem fontsize--tiny " +
            el_class +
            "' style='width:" +
            el_percent +
            "%'><div class='stackeditem__bg' style='background-color:" +
            $el.data("color") +
            ";'></div><div class='stackeditem__info'><h4 class='stackeditem__value fontsize--tiny'>" +
            parseInt(el_percent) +
            "%</h4></div></div>"
        );
      });
    });
  } // charts__line_init ()

  function charts__stacked_reduce(a, b) {
    return a + b;
  } //charts__stacked_reduce

  /*  ==========================================================================
			WooCommerce
			========================================================================== */

  /* Hide Alert / Notice */

  // This needs to be "delegate" instead of "click" to make sure it also works on dynamic content
  $("body").delegate(".woocommerce-message__hide", "click", function () {
    $(this).parent().fadeOut();
  });

  setTimeout(function () {
    $(".siteheader__cart__alert .woocommerce-message").fadeOut();
    $(".siteheader__cart__alert .woocommerce-error").fadeOut();
  }, 4000);

  /*  ==========================================================================
			Ninja Forms -- Stripe
			========================================================================== */

  // Check if checkout pop up is open
  setInterval(function () {
    if ($(".nf-error-msg").text().length > 0) {
      // reset loading icon
      $("#stripe-loading").removeClass("stripe-success");
      // Show loading symbol
      $("#stripe-loading").css("display", "none");
    } else if ($(".stripe_checkout_app").length) {
      $(".stripe_checkout_app").each(function (index) {
        if ($(this).css("display") === "block") {
          // reset loading icon
          $("#stripe-loading").removeClass("stripe-success");
          // Show loading symbol
          $("#stripe-loading").css("display", "block");
        } else if ($(this).css("display") === "none") {
          // reset loading icon
          $("#stripe-loading").removeClass("stripe-success");
          // Show loading symbol
          $("#stripe-loading").css("display", "none");
        }
      });
    }
  }, 50);

  // Check if success msg is set to display block
  setInterval(function () {
    $(".nf-response-msg").each(function (index) {
      if ($(this).css("display") === "block") {
        // Add success class and then hide loading symbol
        $("#stripe-loading .stripe-loading").addClass("stripe-loading--success");
        setTimeout(function () {
          $("#stripe-loading").css("display", "none");
        }, 1500);
      }
    });
  }, 50);

  /*  ==========================================================================
			Ninja Forms -- Events
			========================================================================== */

  if ($("body").hasClass("event-template-single-event--registrationform")) {
    // Check if success msg is set to display block
    var complete = false;
    setInterval(function () {
      $(".nf-response-msg").each(function (index) {
        if ($(this).css("display") === "block") {
          // Add success class and then hide loading symbol
          if (!complete) {
            $("body").addClass("registration-success");
            $("html, body").animate(
              {
                scrollTop: $(".pageheader").offset().top + $(".pageheader").height()
              },
              400
            );
            complete = true;
          }
        }
      });
    }, 50);
  }

  /*  ==========================================================================
			Test Blend Mode
			========================================================================== */

  var mixBlendModeSupport = Modernizr.testProp("mixBlendMode");

  if (!mixBlendModeSupport) {
    $("body").addClass("no-mixBlendMode");
  } else {
    $("body").addClass("mixBlendMode");
  }

  /*  ==========================================================================
			Owl Carousel - Featured Events Flex
			========================================================================== */

  var flexevents__carousel = $(".flexevents__carousel");

  flexevents__carousel.on("initialized.owl.carousel changed.owl.carousel resized.owl.carousel", function (e) {
    $(e.target).toggleClass("hide-owl-next", e.item.index >= e.item.count - e.page.size);
    $(e.target).toggleClass("hide-owl-prev", e.item.index === 0);
  });

  flexevents__carousel.on("changed.owl.carousel", function (event) {
    lazyLoadInstance.update();
  });

  flexevents__carousel.owlCarousel({
    loop: false,
    margin: 10,
    nav: true,
    dots: false,
    navText: ["<i class='fa fa-chevron-left'></i>", "<i class='fa fa-chevron-right'></i>"],
    callbacks: true,
    responsive: {
      0: {
        items: 2
      },
      700: {
        items: 3
      },
      1200: {
        items: 4
      }
    }
  });

  /*  ==========================================================================
		flex--shareimgs grid
		========================================================================== */

  var $image_grid = $(".flexshareimgs .gd-g").isotope({
    // set itemSelector so .grid-sizer is not used in layout
    itemSelector: ".gd-u",
    percentPosition: true,
    masonry: {
      // use element for option
      columnWidth: ".grid-sizer"
    }
  });

  // layout Isotope after each image loads
  $image_grid.imagesLoaded().progress(function () {
    $image_grid.isotope("layout");
  });

  /*  ==========================================================================
		Ninja Forms
		========================================================================== */
  jQuery(document).on("nfFormReady", function () {
    $(".nf-mp-body").find(".openticketwrap").closest(".nf-row").addClass("ticket-wrapper");

    $(".nf-field-qty").each(function (index) {
      $(this).val("0");
    });

    $(".ticket-day .list-radio-wrap li label").click(function () {
      var SelectedDay = $(this).text();
      $(".selected-day").html("");
      $(".selected-day").append(SelectedDay);
      $(".selected-day-wrapper").addClass("show-selected");
    });

    $(".nf-product-quantity").change(function () {
      window.setTimeout(function () {
        var registrationTotal = $(".registration-total").text();
        $(".overall-total").html("");
        $(".overall-total").append(registrationTotal);
      }, 300);
    });

    nfRadio.channel("nfMP").on("change:part", function () {
      $(".ticket-day .list-radio-wrap li label").click(function () {
        var SelectedDay = $(this).text();
        $(".selected-day").html("");
        $(".selected-day").append(SelectedDay);
        $(".selected-day-wrapper").addClass("show-selected");
      });

      $(".nf-mp-body").find(".openticketwrap").closest(".nf-row").addClass("ticket-wrapper");
    });
  });
}); // End of $(function () { ... })

function effects__init($effects) {
  $effects.each(function () {
    var $el = $(this);
    $el.waypoint({
      handler: function (direction) {
        if (direction === "down") {
          $el.addClass("effect--ready");
        }
      },
      offset: "90%"
    });
  });
} // effects__init()

/*  ==========================================================================
  Load more
		========================================================================== */

$(".ajaxloadmore").click(function () {
  var button = $(this),
    post_type = button.data("post-type"),
    taxonomy = button.data("taxonomy"),
    term_id = button.data("termid");

  var data = {
    action: "loadmore",
    post_type: post_type,
    page: loadmore_params.current_page
  };

  if (taxonomy) {
    data.taxonomy = taxonomy;
  }
  if (term_id) {
    data.term_id = term_id;
  }

  $.ajax({
    url: loadmore_params.ajaxurl,
    type: "POST",
    data: data,
    beforeSend: function () {
      button.html("Loading...");
    },
    success: function (response) {
      if (response.success && response.data.html) {
        $(".posts").append(response.data.html);

        loadmore_params.current_page = response.data.current;

        button.html("Load more");

        if (loadmore_params.current_page >= response.data.max_pages) {
          button.closest(".loadmore").remove();
        }

        var $effects = $(".effect");
        if ($effects.length > 0) {
          effects__init($effects);
        }
        lazyLoadInstance.update();
      } else {
        // no posts returned, remove button immediately
        button.closest(".loadmore").remove();
      }
    }
  });
});

/*  ==========================================================================
  Maps JS
		========================================================================== */

// (function ($) {
/* jshint ignore:start */
/*
 *  document ready
 *
 *  This function will render each map when the document is ready (page has loaded)
 *
 *  @type	function
 *  @date	8/11/2013
 *  @since	5.0.0
 *
 *  @param	n/a
 *  @return	n/a
 */
// global var
// let map;

// async function initMap() {
//   // Request needed libraries.

//   const { Map } = await google.maps.importLibrary("maps");
//   const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
//   const { LatLngBounds } = await google.maps.importLibrary("core");

//   const maps = document.querySelectorAll(".map__container");

//   const mapsInit = function (maps) {
//     maps.forEach(function (single_map) {
//       let acf_map = single_map.querySelector(".acf-map");

//       // Get all markers on the page.
//       const properties = [];
//       var markers = single_map.querySelectorAll(".marker");

//       markers.forEach(function (marker) {
//         properties.push({
//           position: {
//             lat: parseFloat(marker.dataset.lat),
//             lng: parseFloat(marker.dataset.lng)
//           }
//         });
//       });

//       map = new Map(acf_map, {
//         zoom: 15,
//         center: new google.maps.LatLng(0, 0),
//         mapId: "cd86cd7e50955953",
//         mapTypeId: google.maps.MapTypeId.ROADMAP,
//         disableDefaultUI: true // a way to quickly hide all controls
//       });

//       // Go through Markers and set markers position and marker icon
//       properties.forEach(property => {
//         const markerImg = document.createElement("img");

//         markerImg.src = loadmore_params.template_url + "/img/map_marker.png";

//         const AdvancedMarkerElement = new google.maps.marker.AdvancedMarkerElement({
//           map,
//           position: property.position,
//           content: markerImg
//         });
//       });

//       // more then  1 marker?
//       if (properties.length !== 1) {
//         // This function will center the map, showing all markers attached to this map
//         const bounds = new google.maps.LatLngBounds();
//         // loop through all markers and create bounds
//         $.each(properties, function (i, marker) {
//           var latlng = new google.maps.LatLng(marker.position.lat, marker.position.lng);
//           bounds.extend(latlng);
//         });
//         // set center of map
//         map.fitBounds(bounds);
//       } else {
//         map.setCenter(new google.maps.LatLng(properties[0].position.lat, properties[0].position.lng));
//       }
//     });
//   };

//   mapsInit(maps);
// }

// const maps = document.querySelectorAll(".map__container");

// initMap();
/* jshint ignore:end */
// })(jQuery);

/*  ==========================================================================
    LazyLoad - Enable Lazy load for images
    ========================================================================== */

// Lazy load images (or everything with .lazy)
var lazyLoadInstance = new LazyLoad();

/*  ==========================================================================
    Video Messages
    ========================================================================== */

var $videoMessage = $(".flex--videomessages");
if ($videoMessage.length > 0) {
  videoMessageInit();
}
function videoMessageInit() {
  const copyURL = document.querySelectorAll(".copy__video__url");
  const copyURLWrapper = document.querySelector(".copy__video__url__wrapper");
  copyURL.forEach(function (copyButton) {
    copyButton.addEventListener("click", function (e) {
      e.preventDefault();

      var dummy = document.createElement("input"),
        text = window.location.href;

      document.body.appendChild(dummy);
      dummy.value = text;
      dummy.select();
      document.execCommand("copy");
      document.body.removeChild(dummy);

      copyURLWrapper.classList.add("active");
      window.getSelection().removeAllRanges();
      setTimeout(function () {
        copyURLWrapper.classList.remove("active");
      }, 2500);
    });
  });

  const messageSelector = document.querySelectorAll(".message__selector");

  if (!messageSelector) {
    return;
  }

  messageSelector.forEach(messageSelect => {
    messageSelect.addEventListener("change", function () {
      const selectedValue = this.value;
      updateURL(selectedValue);
      showContent(selectedValue);
    });
  });

  function showContent(number) {
    const accordions = document.querySelectorAll(".message__accordion");
    accordions.forEach(accordion => {
      accordion.style.display = "none";
    });
    const target = document.getElementById(`${number}`);
    if (target) {
      target.style.display = "block";
    }
  }

  // Function to update the URL without reloading the page
  function updateURL(contentNumber) {
    if (history.pushState) {
      const newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?video_message=" +
        contentNumber;
      window.history.pushState({ path: newurl }, "", newurl);
    }
  }

  // Function to read a URL parameter
  function getURLParameter(name) {
    const results = new RegExp("[?&]" + name + "=([^&#]*)").exec(window.location.href);
    return results ? results[1] : undefined;
  }

  function setSelectedOption(contentToShow) {
    messageSelector.forEach(messageSelect => {
      messageSelect.scrollIntoView({ behavior: "smooth", block: "start" });
      const options = messageSelect.options;
      for (let option of options) {
        if (option.value === contentToShow) {
          messageSelect.value = contentToShow;
          break;
        }
      }
    });
  }

  // Check for URL parameter and adjust accordion accordingly
  const contentToShow = getURLParameter("video_message");
  if (contentToShow) {
    showContent(contentToShow);
    setSelectedOption(contentToShow);
  }
}

/*  ==========================================================================
    Pledge Form
    ========================================================================== */
var $pledgeForm = $(".pledgeform__pin");
if ($pledgeForm.length > 0) {
  $pledgeForm.each(function () {
    var $el = $(this);
    $el.waypoint({
      element: $el,
      handler: function (direction) {
        if (direction === "down") {
          if (!!$.cookie("pledge_form")) {
          } else {
            $(".pledgeform").addClass("pledgeform--ready");
          }
        }
      },
      offset: "1%"
    });
  });

  $(document).on("nfFormSubmitResponse", function (event, response) {
    if (response.id === "265") {
      $(".pledgeform").removeClass("effect effect--ready .effect--fade");
      $.cookie("pledge_form", "hide");
    }
  });

  $(".pledgeform__dismiss a").click(function (e) {
    $(".pledgeform").removeClass("pledgeform--ready");
    $.cookie("pledge_form", "hide", { expires: 7 });
  });
}

/*  ==========================================================================
   Disclaimer Popup
    ========================================================================== */
var $disclaimerPopup = $(".disclaimer__popup");
if ($disclaimerPopup.length > 0) {
  disclaimer__links__init();
}
function disclaimer__links__init() {
  var $disclaimer_page_link = $(".page-template-template-realtalk a").not(".disclaimer__popup a, .pledgeform a");

  $disclaimer_page_link.each(function () {
    var $this = $(this);

    $this.on("click", function (e) {
      e.preventDefault();
      $(".disclaimer__popup").addClass("disclaimer__popup--active");
      $("body").addClass("pledge-popup-active");
      $(".disclaimer__goto").on("click", function () {
        window.location.href = $this.attr("href");
      });
    });
  });

  $(".disclaimer__close").on("click", function () {
    $("body").removeClass("pledge-popup-active");
    $(".disclaimer__popup").removeClass("disclaimer__popup--active");
  });
} // disclaimer__links__init()

var $contentCols = $(".flex--contentcols");
if ($contentCols.length > 0) {
  contentcols__height__init();

  $(window).on("resize", function () {
    contentcols__height__init();
  });
}
function contentcols__height__init() {
  const contentCols = document.querySelectorAll(".flex--contentcols");

  contentCols.forEach(function (contentCol) {
    const topHeights = contentCol.querySelectorAll(".flex__toparea");
    let tallestHeight = 0;
    topHeights.forEach(function (topHeight) {
      let elementHeight = topHeight.offsetHeight;

      if (elementHeight > tallestHeight) {
        tallestHeight = elementHeight;
      }
    });

    topHeights.forEach(function (topHeight) {
      topHeight.style.height = tallestHeight + "px";
    });
    tallestHeight = 0;
  });
}

/*  ==========================================================================
    GENERAL - Initiate plyr (custom video controls)

    This is automatically disabled on builds, to enable uncomment the JS here
    and then go to functions / enqueue-scripts and enqueue-styles to uncomment and enable the css and JS 

    ========================================================================== */

function plyrsInit(context = document) {
  const plyrs = context.querySelectorAll(".flexlandingpagevideo__videocode, .testimonial__video .plyr");

  console.log("Found plyr elements:", plyrs);

  if (!plyrs.length) {
    return;
  }

  plyrs.forEach(function (el) {
    if (el.dataset.plyrInitialized === "true") {
      return;
    }

    const player = new Plyr(el, {
      controls: ["play"],
      clickToPlay: true,
      vimeo: {
        controls: false,
        title: false,
        byline: false,
        portrait: false,
        speed: false,
        transparent: false,
        dnt: true
      }
    });

    el.dataset.plyrInitialized = "true";
  });
}
document.addEventListener("DOMContentLoaded", function () {
  plyrsInit();
});

document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("mc-embedded-subscribe-form--header");
  const thankYou = document.getElementById("thank-you--header");
  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault(); // stop normal submit

      const formData = new FormData(form);

      fetch(form.action, {
        method: "POST",
        body: formData,
        mode: "no-cors" // Mailchimp doesn’t send CORS headers
      })
        .then(() => {
          form.style.display = "none";
          thankYou.style.display = "block";
        })
        .catch(e => {
          // you can show an error message if you want
          alert("Something went wrong. Please try again.", e);
        });
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("mc-embedded-subscribe-form--module");
  const thankYou = document.getElementById("thank-you--module");

  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault(); // stop normal submit

      const formData = new FormData(form);

      fetch(form.action, {
        method: "POST",
        body: formData,
        mode: "no-cors" // Mailchimp doesn’t send CORS headers
      })
        .then(() => {
          form.style.display = "none";
          thankYou.style.display = "block";
        })
        .catch(() => {
          // you can show an error message if you want
          alert("Something went wrong. Please try again.");
        });
    });
  }
});

/*  ==========================================================================
   Copy Button
    ========================================================================== */
var $toolkitCopyText = $(".toolkit-copytext");
if ($toolkitCopyText.length > 0) {
  toolkit__copy__init();
}
function toolkit__copy__init() {
  const toolkitbtn = document.querySelectorAll(".copy-btn");

  toolkitbtn.forEach(btn => {
    btn.addEventListener("click", () => {
      const container = btn.closest(".toolkit-copytext");
      const textEl = container.querySelector(".copy-text");
      const msgEl = container.querySelector(".copy-message");
      const text = textEl.innerText || "";

      navigator.clipboard
        .writeText(text)
        .then(() => {
          msgEl.style.display = "inline";
          msgEl.textContent = "Copied!";
          setTimeout(() => (msgEl.style.display = "none"), 2000);
        })
        .catch(err => {
          console.error("Clipboard copy failed:", err);
        });
    });
  });
}

/*  ==========================================================================
   Download File
    ========================================================================== */

var $assetCol = $(".asset");
if ($assetCol.length > 0) {
  asset__col__init();
}

function asset__col__init() {
  const downloadLinks = document.querySelectorAll(".download-link");

  downloadLinks.forEach(function (link) {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      const target = e.currentTarget;
      const fileUrl = target.dataset.url;
      const fileName = fileUrl.split("/").pop();
      const fileExt = fileName.split(".").pop().toLowerCase();

      let mimeType;
      if (/(jpg|jpeg|png|gif|webp|bmp|heic)/.test(fileExt)) {
        mimeType = "image/" + (fileExt === "jpg" ? "jpeg" : fileExt);
      } else if (/(mp4|mov|avi|webm|mkv)/.test(fileExt)) {
        mimeType = "video/" + fileExt;
      } else {
        mimeType = "application/octet-stream";
      }

      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

      if (isIOS && navigator.canShare) {
        fetch(fileUrl)
          .then(function (res) {
            return res.blob();
          })
          .then(function (blob) {
            const type = blob.type || mimeType;
            const file = new File([blob], fileName, { type: type });

            const isImage = type.indexOf("image/") === 0;
            const isVideo = type.indexOf("video/") === 0;

            let title;
            let text;

            if (isImage) {
              title = "Save or share this image";
              text = "Tap 'Save Image' to add it to your gallery.";
            } else if (isVideo) {
              title = "Save or share this video";
              text = "Tap 'Save Video' to add it to your gallery.";
            } else {
              title = "Save or share this file";
              text = "Choose an app to save or share this file.";
            }

            if (navigator.canShare({ files: [file] })) {
              return navigator.share({
                files: [file],
                title: title,
                text: text
              });
            } else {
              // fallback if cannot share this file type
              fallbackDownload(fileUrl, fileName);
            }
          })
          .catch(function (err) {
            console.error("Share failed, falling back to download:", err);
            fallbackDownload(fileUrl, fileName);
          });
      } else {
        fallbackDownload(fileUrl, fileName);
      }
    });
  });

  // Fallback download helper
  function fallbackDownload(fileUrl, fileName) {
    const a = document.createElement("a");
    a.href = fileUrl;
    a.download = fileName;
    a.rel = "nofollow";
    a.setAttribute("data-fancybox", "false");
    document.body.appendChild(a);
    a.dispatchEvent(new MouseEvent("click", { bubbles: true, cancelable: true }));
    document.body.removeChild(a);
  }
}
